import React, { PureComponent } from 'react';

import { createContainer } from '@dbk-legacy/muster/react';

import Text, { Small } from '@dbk/ui-text';
import { List, ListItem } from '@dbk/ui-list';
import TitleHeader from './title-header';
import { TextInput } from 'react-native';
import { Edit } from '@dbk/ui-icons';

import styles from './alert-management.styles';

class AlertList extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
    this.props.marque.getAllMarqueData();
  }

  handleActionbutton(row) {
    this.props.marque.editMarque(row);
    this.props.replacePage({ pathname: '/admin/alertmanagement' });
  }

  renderListItem(row) {
    const { configType, channel, validFromDt, validToDt } = row;
    let channelType = '';
    switch (channel.toUpperCase()) {
      case 'MOBILE':
        channelType = 'Mobile/Tablet';
        break;
      case 'WEB':
        channelType = 'Desktop';
        break;
      case 'ALL':
        channelType = 'All';
        break;
      default:
        break;
    }
    return (
      <div className="row margin-top-15 margin-bottom-15">
        <div className="columns small-12 medium-2 text-align-center">
          <Text secondary>{channelType}</Text>
        </div>
        <div className="columns small-12 medium-3 text-align-center">
          <Text secondary>
            {validFromDt} to {validToDt}
          </Text>
        </div>
        <div className="columns small-12 medium-5 text-align-center">
          <Text secondary>{configType}</Text>
        </div>
        <div
          className="columns small-12 medium-2 text-align-center"
          onClick={() => this.handleActionbutton(row)}
        >
          <span className="cursor-pointer">
            <Edit width={20} height={20} color={'#ffffff'} />
          </span>
        </div>
      </div>
    );
  }

  renderAlertContent() {
    const {
      marque: { allMarqueData },
      i18n: { messages },
    } = this.props;
    const rowMarkerStyle = { fill: 'transparent' };
    return (
      <div className="row small-12 large-12 pad-20 ">
        <div className="row pad-left-25 pad-right-10 margin-bottom-15">
          <div className="columns small-12 medium-2 text-align-center">
            <Small secondary>{messages['app.common.marque.channel']}</Small>
          </div>
          <div className="columns small-12 medium-3 text-align-center">
            <Small secondary>{messages['app.common.marque.msgPeriod']}</Small>
          </div>
          <div className="columns small-12 medium-5 text-align-center">
            <Small secondary>{messages['app.common.marque.msgType']}</Small>
          </div>
          <div className="columns small-12 medium-2 text-align-center">
            <Small secondary>{messages['app.common.marque.action']}</Small>
          </div>
        </div>

        {allMarqueData && (
          <List className="marque-list">
            {allMarqueData.map((row) => (
              <ListItem>{this.renderListItem(row)}</ListItem>
            ))}
          </List>
        )}
      </div>
    );
  }

  render() {
    return (
      <div className="profile-container">
        <div className="row small-12 large-10">
          <div className="callout module border-none">
            <TitleHeader />
            {this.renderAlertContent()}
          </div>
        </div>
      </div>
    );
  }
}

export default createContainer({
  $queries: {
    changePage: { $call: 'ui.history.push' },
    replacePage: { $call: 'ui.history.replace' },
    marque: {
      getAllMarqueData: { $call: 'getAllMarqueData' },
      allMarqueData: true,
      editMarque: { $call: 'editMarque' },
    },
    i18n: {
      messages: true,
    },
  },
})(AlertList);
